import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/design-system";
import { FilterBlockEditor, Popover, PopoverContent, PopoverTrigger } from "@tellescope/ui";
import { type FreeformFieldOption, type FreeformFilterBlock } from "@tellescope/utils";
import { ListFilter } from "lucide-react";
import { TICKETS_CUSTOM_VALUE_FIELDS, TicketsFilterValueInput } from "./TicketsFilterValueInput";

export interface TicketsFilterPopoverProps {
  filterBlock: FreeformFilterBlock;
  fieldOptions: FreeformFieldOption[];
  stageOptions: Array<{ value: string; label: string }>;
  priorityOptions: Array<{ value: string; label: string }>;
  tagOptions: string[];
  onFilterChange: (block: FreeformFilterBlock) => void;
}

export const TicketsFilterPopover = ({
  filterBlock,
  fieldOptions,
  stageOptions,
  priorityOptions,
  tagOptions,
  onFilterChange,
}: TicketsFilterPopoverProps) => {
  const { t } = useTranslation("contacts");

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button iconOnly variant="ghost" size="sm" color="muted" hoverLabel={t("Filter tickets")}>
          <ListFilter />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-96 p-2" align="end">
        <FilterBlockEditor
          block={filterBlock}
          fieldOptions={fieldOptions}
          onChange={onFilterChange}
          onRemove={() => onFilterChange({ ...filterBlock, filters: [] })}
          renderValueInput={({ filter, onChange }) =>
            TICKETS_CUSTOM_VALUE_FIELDS.includes(filter.field) ? (
              <TicketsFilterValueInput
                filter={filter}
                onChange={onChange}
                stageOptions={stageOptions}
                priorityOptions={priorityOptions}
                tagOptions={tagOptions}
              />
            ) : undefined
          }
        />
      </PopoverContent>
    </Popover>
  );
};
